import React, { useState } from "react";
import {
  useGetAllKlischeThikness,
  useGetGetAllKlischeType,
} from "../../../Production/OrderArchive/Hook";
import DySelect from "../../../../General/Components/DySelect/DySelect";
import { Box, Grid } from "@mui/material";
import YearsDrop from "../components/YearsDrop";
import PersianDatePicker from "../components/PersianDatePicker";

function FilterKilscheTypeAndThicknes({
  KilscheThicknes,
  setKilscheThicknes,
  KlischeType,
  setKlischeType,
  chartFilter,
  year,
  setYear,
  month,
  setMonth,
}) {
  //*KilscheType
  const { data } = useGetGetAllKlischeType();

  const convertDataToOptionSelect = data?.map((item) => ({
    value: item.id,
    key: item.klischeTypeName,
  }));

  //*KilscheThicknes

  const { data: thickness } = useGetAllKlischeThikness(KlischeType.KlischeType);
  const convertDataToOptionKilscheThicknes = thickness?.map((item) => ({
    value: item.id,
    key: item.thickness,
  }));
  return (
    <Box sx={{ display: "flex", width: { md: "60%", xs: "100%" } }}>
      {chartFilter.enum === 0 && (
        <PersianDatePicker
          year={year}
          setYear={setYear}
          month={month}
          setMonth={setMonth}
        />
      )}
      {chartFilter.enum === 1 && (
        <Grid sx={{ marginRight: "4px" }}>
          {" "}
          <YearsDrop year={year} setYear={setYear} />{" "}
        </Grid>
      )}
      <DySelect
        label={"نوع کلیشه"}
        selectValue={KlischeType}
        setSelectValue={setKlischeType}
        name={"KlischeType"}
        items={convertDataToOptionSelect}
      />
      <DySelect
        label={"ضخامت کلیشه"}
        selectValue={KilscheThicknes}
        setSelectValue={setKilscheThicknes}
        name={"KilscheThicknes"}
        items={convertDataToOptionKilscheThicknes}
      />
    </Box>
  );
}

export default FilterKilscheTypeAndThicknes;
